import _wellKnownSymbol from "../internals/well-known-symbol";
var exports = {};
var wellKnownSymbol = _wellKnownSymbol;
exports.f = wellKnownSymbol;
export default exports;